import { formatPdpCarat } from '@/features/pdp/utils/formatPdpCarat';
import { WeightInfoTooltip } from './WeightInfoTooltip';

const WEIGHT_VARIATION_TEXT =
  'The final invoice amount will be adjusted in case of variation in weight.';

interface PdpMobileSolitaireTileContentProps {
  solitaireCarat: number;
  onInfoIconClick?: (label: string) => void;
}

export function PdpMobileSolitaireTileContent({
  solitaireCarat,
  onInfoIconClick,
}: PdpMobileSolitaireTileContentProps) {
  return (
    <div className="mx-auto flex w-full flex-col items-center text-center">
      <div className="mb-[3px] whitespace-nowrap border-b border-[#ededed] text-[16.8px] leading-[1.5em] tracking-[1px] max-[359px]:text-xs">
        {formatPdpCarat(solitaireCarat)}{' '}
        <span className="text-[13px] tracking-[0.7px]">Ct</span>
      </div>
      <WeightInfoTooltip
        label="Solitaires Weight"
        text={WEIGHT_VARIATION_TEXT}
        onInfoClick={onInfoIconClick}
      />
    </div>
  );
}
